import clsx from 'clsx';
import { isExistFunction } from '../../../../../utils';

const Input = (props) => {
  const {
    formInputRef,
    inputRef,
    label,
    labelHidden,
    inputId,
    errorMessage,
    type,
    name,
    inputClass,
    required,
    inputMode,
    formGroupClass,
    onClick,
    onKeyDown,
    onBlur,
    onFocus,
    onChange,
    onInput,
    onInvalid,
    onReset,
    onSubmit,
    isValid,
    placeholder,
    value,
    colorLabel,
    iconInput,
    clickIcon,
  } = props;

  const requiredClass = required ? 'required' : '';

  const handleOnChange = (e) => {
    if (isExistFunction(onChange)) {
      onChange(e);
    }
  };

  const handleOnInput = (e) => {
    if (isExistFunction(onInput)) {
      onInput(e);
    }
  };

  const handleOnInvalid = (e) => {
    if (isExistFunction(onInvalid)) {
      onInvalid(e);
    }
  };

  const handleOnReset = (e) => {
    if (isExistFunction(onReset)) {
      onReset(e);
    }
  };

  const handleOnSubmit = (e) => {
    if (isExistFunction(onSubmit)) {
      onSubmit(e);
    }
  };

  const handleOnFocus = (e) => {
    if (isExistFunction(onFocus)) {
      onFocus(e);
    }
  };

  const handleOnBlur = (e) => {
    if (isExistFunction(onBlur)) {
      onBlur(e);
    }
  };

  const handleOnKeyDown = (e) => {
    if (isExistFunction(onKeyDown)) {
      onKeyDown(e);
    }
  };

  const handleOnClick = (e) => {
    if (isExistFunction(onClick)) {
      onClick(e);
    }
  };

  return (
    <div ref={formInputRef} className={clsx('form-group form-group-v2', formGroupClass, isValid ? '' : 'invalid')}>
      <div className="relative form-inner z-1">
        {label &&
          <label htmlFor={inputId}
            className={`absolute m-0 pointer-events-none label-animation top-6 left-8 z-1 ${colorLabel || 'text-gray-650'} ${labelHidden ? 'sr-only' : ''}`}>
            {label}
            {required &&
              <span>*</span>
            }
          </label>
        }
        {!isValid &&
          <span className="error-message text-primary-100 absolute text-xs right-3 top-0">{errorMessage}</span>
        }
        <input ref={inputRef} type={type || 'text'} name={name} id={inputId} inputMode={inputMode} placeholder={placeholder}
          value={value}
          className={clsx('form-control border-gray-550 px-8', inputClass, requiredClass)}
          onClick={handleOnClick}
          onKeyDown={handleOnKeyDown}
          onBlur={handleOnBlur}
          onFocus={handleOnFocus}
          onChange={handleOnChange}
          onInput={handleOnInput}
          onInvalid={handleOnInvalid}
          onReset={handleOnReset}
          onSubmit={handleOnSubmit}
        />
        {iconInput &&
          <span className="absolute right-8 top-6">
            <button type="button" aria-label="zipcode filter" className={iconInput} onClick={clickIcon} />
          </span>
        }
      </div>
    </div>
  );
};

export default Input;